export const TABS = {
  HOME: "HOME",
  CALENDAR: "CALENDAR",
  CONTACT: "CONTACT",
  RSVP: "RSVP",
  LOCATION: "LOCATION",
  AUDIO: "AUDIO",
};
